import React from "react";
import Lottie from "lottie-light-react";
import gears from "~assets/animations/gears.json";
import Typography from "@mui/material/Typography";

interface LoadingViewGearsProps {
  title?: string;
}

const LoadingViewGears: React.FC<LoadingViewGearsProps> = ({ title }) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
      }}
    >
      <div style={{ width: 210 }}>
        <Lottie loop={true} autoPlay={true} animationData={gears} />
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          width: "100%",
          maxWidth: 500,
        }}
      >
        {title && (
          <Typography
            variant="h6"
            style={{
              padding: 30,
              color: "#503181",
              fontWeight: "bold",
              fontSize: 19,
            }}
          >
            {title}
          </Typography>
        )}
      </div>
    </div>
  );
};

export default LoadingViewGears;
